import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { TokenService } from "../tokenManagement/token.service";
import { Notification } from "./notification";
// import { throwError } from "rxjs/internal/observable/throwError";

@Injectable()
export class ErrorHandlers {
  constructor(
    private notservice: Notification,
    private router: Router,
    private tokenservice: TokenService
  ) {}

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log(error);
      // A client-side or network error occurred. Handle it accordingly.
      //   console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
    }
    // return an observable with a user-facing error message
    // return throwError( 'Something bad happened; please try again later.');
    // return new ErrorObservable(error);
    // return throwError(error);
  }

  //generic handling of all errors
  customclienterrors(
    toastMessageHeader: string,
    errorCode: any,
    errorMessage: string
  ) {
    if (errorCode > 399 && errorCode < 500) {
      this.notservice.Error(toastMessageHeader, errorMessage);
    }
    if (errorCode == 502) {
      this.notservice.Error(
        "Server Busy!",
        "The server is busy, Kindly try again later"
      );
    }
    if (errorCode > 499) {
      this.notservice.Error(toastMessageHeader, errorMessage);
    }
    if (errorCode == 0) {
      this.notservice.Error(
        "Connection Failed!!",
        "Cannot connect to the server."
      );
    }

    if (errorCode == 401) {
      this.router.navigate(["/login"]);
      this.notservice.Warning("Expired Session", "oops! Kindly Login again");
    }
    if (errorCode == 401) {
      //  this.notservice.Warning("Expired Session","oops! Kindly Login again")
      this.tokenservice.clearStorage();
      // location.reload();
      this.router.navigate(["/login"]);
    }
  }
}
